<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="btn-home col-md-12 mt-3 mb-4 d-flex justify-content-end">
          <button type="button" class="btn btn-outline-main" @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
      </div>
      <div id="div-modal-cxc" class="d-flex justify-content-center">
        <div id="div-cxc" class="card w-100">
          <div class="card-header text-white h4 text-center" style="background: #900052">
            <strong>ANULACION DE MOV. ENTRE ALMACENES - FARMACIA</strong>
          </div>
          <div class="card-body w-100">
            <div class="row">
              <div class="col-md-12 py-2 px-4">
                <div class="row d-flex">
                  <!--Fecha Filtro -->
                  <template>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 px-1 mb-2">
                        <div class="input-group input-group-sm w-100">
                          <span class="input-group-text">Desde</span>
                          <input
                            type="date"
                            @input="mtdGetData()"
                            aria-label="shift_date"
                            class="form-control form-control-sm"
                            id="init"
                            v-model="filter.init"
                          />
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 px-1 mb-2">
                        <div class="input-group input-group-sm w-100">
                          <span class="input-group-text">Hasta</span>
                          <input
                            @input="mtdGetData()"
                            type="date"
                            aria-label="shift_date"
                            class="form-control form-control-sm"
                            id="end"
                            v-model="filter.end"
                          />
                        </div>
                    </div>
                  </template>
                </div>
              </div>
              <!--Fin Filtro-->

              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 mb-4 table-container"
              >
                <table
                  id="tb-anular"
                  class="table table-bordered border-main mb-0 px-0 text-xs"
                >
                  <thead>
                    <tr
                      class="text-white border-white text-center"
                      style="background: #900052; vertical-align: middle"
                    >
                      <th scope="col">DOCUMENTO</th>
                      <th scope="col" class="table-th-acciones">FECHA <small style="display: block; margin-top: -4px;">ANULACIÓN</small></th>
                      <th scope="col">ALMACEN ORIGEN</th>
                      <th scope="col">ALMACEN DESTINO</th>
                      <th scope="col" class="table-th-acciones">ESTADO</th>
                      <th scope="col" class="table-th-acciones">ACCIONES</th>
                    </tr>
                  </thead>

                  <tbody class="custom-table">
                    <tr v-if="cpData.length == 0">
                      <td class="text-center align-middle" colspan="7">Sin Registros</td>
                    </tr>
                    
                    <tr class="text-center" style="vertical-align: middle" v-for="(item, index) in cpData" :key="index">
                        <td><strong>{{ item.correlative }}</strong></td>
                        <td>{{ item.anulation_date | formatDateTime }}</td>
                        <td>{{ item.almacenOrigen ? item.almacenOrigen : "-"  }}</td>
                        <td>{{ item.almacenDestino ? item.almacenDestino : "-"  }}</td>
                        <td>
                          <span :style="badgeStyle(item.anulation_state)">
                            {{ stateAnnular(item.anulation_state) }}
                          </span>
                        </td>
                        <td class="text-nowrap"> 
                          <div class="d-flex d-md-block justify-content-center">
                            <button 
                                @click="viewDetail(item, item.details)" class="btn btn-info btn-sm rounded-circle me-1 text-white" title="Detalle Mov.">
                                <i class="fa fa-eye"></i>
                            </button>
                            <button 
                                @click="viewpdf(item.id)"  class="btn btn-primary btn-sm rounded-circle me-1 text-white" title="PDF Mov.">
                                <i class="fas fa-solid fa-file-pdf"></i>
                            </button>
                            <button v-if="item.anulation_state == 1"
                                @click="annular(item.id, item.details)"  class="btn btn-success btn-sm rounded-circle text-white" title="Aceptar o Rechazar Anulación">
                                <i class="fas fa-edit"></i>
                            </button>
                            <button v-if="item.anulation_state == 4"
                                @click="mtdChangeToPending(item.id)"  class="btn btn-warning btn-sm rounded-circle text-white" title="Aceptar o Rechazar Anulación">
                                <i class="fas fa-reply"></i>
                            </button>
                          </div>
                        </td>
                    </tr>
                  
                  </tbody>
                </table>
              </div>

              <!--pag-->
              <div
                v-if="cpData.length > 0 && showTable"
                class="d-flex justify-content-center px-1 mb-4"
              >
                <nav aria-label="Page navigation example">
                  <ul class="pagination mb-1">
                    <li class="page-item">
                      <a
                        class="page-link page"
                        href="javascript:void(0)"
                        @click="backPage"
                        >Anterior</a
                      >
                    </li>
                    <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                      <a
                        :class="selectPage === 1 ? 'page-link active' : 'page-link'"
                        href="javascript:void(0)"
                        @click="selectedPage(1)"
                        >1</a
                      >
                    </li>
                    <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>

                    <li
                      v-for="(item, index) in limitedStepPagination"
                      :key="index"
                      class="page-item"
                    >
                      <a
                        :class="selectPage === item ? 'page-link active' : 'page-link'"
                        href="javascript:void(0)"
                        @click="selectedPage(item)"
                        >{{ item }}
                      </a>
                    </li>
                    <li
                      v-if="
                        limitedStepPagination[limitedStepPagination.length - 1] <
                        stepPagination.length - 1
                      "
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>
                    <li
                      v-if="
                        limitedStepPagination[limitedStepPagination.length - 1] !==
                        stepPagination.length
                      "
                      class="page-item"
                    >
                      <a
                        :class="
                          selectPage === limitedStepPagination.length + 2
                            ? 'page-link active'
                            : 'page-link'
                        "
                        href="javascript:void(0)"
                        @click="selectedPage(stepPagination.length)"
                        >{{ stepPagination.length }}
                      </a>
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link page"
                        href="javascript:void(0)"
                        @click="nextPage"
                        >Siguiente</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cModalMovDetailVue
      :title="modalDeta.title"
      :boo_modal="modalDeta.boo_modal"
      :item="modalDeta.item"
      :id="modalDeta.id"
      @mtdClose="mtdCloseModal"
    />
    <SweetAlert :swal="swal" ref="SweetAlert" @mtdPermissionCommit="mtdPermissionCommit" @mtdPermissionRollback="mtdPermissionRollback"/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import cModalMovDetailVue from "@/components/Farmacia/Modals/cModalMovDetail.vue";

export default {
  name: "historialAlmacen-Pharmacy",
  components: {
    SweetAlert,
    cModalMovDetailVue
  },
  data() {
    return {
      swal: null,
      search: "",
      dataMarca: [],
      selectedMarca: "",
      dataProducto: [],
      selectedProducto: "",
      dataAlmacen: [],
      showTable: false,
      dataShow: [],
      page: 0,
      selectPage: 1,
      stepPagination: [],
      totalPagesToShow: 4,
      showPdf: false,
      filter: {
        init: null,
        end: null,
        almaOrigen: null,
        almaDestino: null,
      },
      dataAlmacenes: [],
      dataDestino: [],
      modalDeta: {
        title: "",
        item: [],
        boo_modal: false,
        id: null,
      },
      dateFilter: false
    };
  },
  created() {
    moment.locale("es");
    this.mtdAsignDate();
    this.mtdGetData();
  },
  watch: {
    selectPage() {
      this.calculateData(7);
    },
  },
  computed: {
    cpData() {
      return this.dataShow;
    },

    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdAsignDate() {
      this.filter.end =
      moment().format("L").substr(6, 4) +
      "-" +
      moment().format("L").substr(3, 2) +
      "-" +
      moment().format("L").substr(0, 2);
      this.filter.init = this.filter.end;
    },

    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/Pharmacy/movement/mtdHistoryMovGerencia",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu: this.$store.getters.get__campus,
        },
      })
        .then((response) => {
            this.dataAlmacen = response.data;
            this.calculateData(7);
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    calculateData(items) {
      if (!this.dataAlmacen || !this.dataAlmacen.length) {
        return (this.dataShow = []);
      }
      let filteredData = this.dataAlmacen;
      let indexInitial = this.selectPage;
      let totalPages = Math.ceil(filteredData.length / items);
      this.stepPagination = Array.from(
        {
          length: totalPages,
        },
        (_, index) => index + 1
      );
      let startIndex = (indexInitial - 1) * items;
      let endIndex = startIndex + (items - 1);
      this.dataShow = filteredData.slice(startIndex, endIndex + 1);
      this.count = this.count + 1;
    },

    viewpdf: function (id) {
      window.open(
        this.$store.getters.get__url +
          "/Pharmacy/movement/viewpdfHistMov/" +
          id,
        "_blank"
      );
    },

    viewDetail: function (item, detail) {
      this.modalDeta.title = 'Detalles de Movimiento: ' + item.correlative;
      this.modalDeta.id = item.id;
      this.modalDeta.item = detail;
      this.modalDeta.boo_modal = true;
    },

    mtdCloseModal: function () {
      this.modalDeta = {
        title: "",
        item: [],
        boo_modal: false,
        id: null,
      };
    },

    //Annular
    stateAnnular(item) {
      switch (item) {
        case 0:
          return "Activo";
        case 1:
          return "Pendiente Anulación";
        case 2:
          return "Anulado";
        case 3:
          return "Anulado Parcial";
        case 4:
          return "Anulación Rechazada";
        case 5:
          return "No se pudo Anular";
        default:
          return "-";
      }
    },

    badgeStyle(state) {
      const colors = {
        0: { background: "green", color: "white" }, // Verde
        1: { background: "blue", color: "white" }, // Azul
        2: { background: "yellow", color: "black" }, // Amarillo
        3: { background: "orange", color: "white" }, // Naranja
        4: { background: "red", color: "white" }, // Rojo
        5: { background: "lightblue", color: "black" }, // Celeste
        default: { background: "gray", color: "white" }, // Plomo
      };
      return {
        padding: "2px 5px",
        borderRadius: "5px",
        fontWeight: "bold",
        fontSize: "11px",
        display: "inline-block",
        ...colors[state] || colors.default,
      };
    },

    annular: function (id, item) {
      this.$refs.SweetAlert.showPermisionsBtn(id, item);
    },

    mtdChangeToPending: function (id) {
      this.$refs.SweetAlert.showUpdateState(id);
    },

    mtdPermissionCommit: function (id, value_select, item) {
      this.post({
        url: this.$store.getters.get__url + "/Pharmacy/movement/annular",
        token: this.$store.getters.get__token,
        params: {
          id: id,
          value_select: value_select,
          detail: item
        },
      })
      .then((response) => {
        if(response.statusCode == 200) {
          if (response.data.value_select == 4) {
              this.$refs.SweetAlert.showSuccess("Anulación Rechazada");
          } else {
            if(response.data.data.anulation_state == 5){
              this.$refs.SweetAlert.showSuccess("No se puedo Anular. Por lo que ya se Utilizo");
            }else if(response.data.data.anulation_state == 2){
              this.$refs.SweetAlert.showSuccess("Anulación Aceptada");
            }else if (response.data.data.anulation_state == 3){
              this.$refs.SweetAlert.showSuccess("Anulado Parcialmente");
            }
          }
          this.mtdGetData();
        } else {
          this.$refs.SweetAlert.showError("Error");
        }
      })
      .catch((errors) => {
        this.$refs.SweetAlert.showError(errors);
      });
    },

    mtdPermissionRollback: function (id, obs, type, state) {
      this.get({
          url: this.$store.getters.get__url + "/Pharmacy/movement/updateStateAnnular/"+ id + "/" + 0,
          token: this.$store.getters.get__token,
      })
      .then((response) => {
        if(response.statusCode == 200) {
          this.$refs.SweetAlert.showSuccess("Estado de Anulacion Cambiado a Pendiente");
          this.mtdGetData();
        } else {
          this.$refs.SweetAlert.showError("Error");
        }
      })
      .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
      });
    },

    //Pag
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(dateTime) {
      return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
};
</script>

<style scoped>
.custom-table th,
.custom-table td {
  font-size: 12px;
}

.table-container {
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: thin;
  scrollbar-color: darkgray lightgray;
  padding-bottom: 10px;
}

.large-text {
  font-size: 9px;
}

.observation-column {
  max-width: 120px; 
  white-space: normal;
  word-wrap: break-word; 
}

.bootom {
  background-color: #900052 !important; 
  border: 0.5px solid #900052 !important;
}
</style>
